/**
=========================================================
* Soft UI Dashboard PRO React - v4.0.0
=========================================================

* Product Page: https://www.creative-tim.com/product/soft-ui-dashboard-pro-react
* Copyright 2022 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/


// react-router-dom components

// Soft UI Dashboard PRO React context

// prop-types is a library for typechecking of props

import Card from "@mui/material/Card";

// Soft UI Dashboard PRO React components
import SoftBox from "components/SoftBox";
import SoftTypography from "components/SoftTypography";

// Soft UI Dashboard PRO React example components
import DashboardLayout from "LayoutContainers/DashboardLayout";
import DashboardNavbar from "components/Skill90DashboardNavbar";

// Soft UI Dashboard PRO React routes

function ApiDocumentation() {
  const apiurl = process.env.REACT_APP_API_DOCUMENTATION_URL + "/api-docs/#/";
  return (
    <DashboardLayout>
      <DashboardNavbar />
      <SoftBox my={3}>
        <Card>
          <SoftBox display="flex" justifyContent="space-between" alignItems="flex-start" p={3}>
            <SoftBox lineHeight={1}>
              <SoftTypography variant="h5" fontWeight="medium">
                Api Documentation
              </SoftTypography>
              <SoftTypography variant="button" fontWeight="regular" color="text">
                All tools you need to calibrate the feed you want to get is in this panel.
              </SoftTypography>
            </SoftBox>
          </SoftBox>
          <div>
            <iframe src={apiurl}></iframe>
          </div>
        </Card>
      </SoftBox>
    </DashboardLayout>
  );
}

// Typechecking props for the DataTable
ApiDocumentation.propTypes = {};

export default ApiDocumentation;
